import {Fragment, observer, React} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {InlineBuilderCardMenuItem, DefaultCatalogContextMenuItems, OpenInC8MenuItem, OpenInWorkspaceMenuItem, useCardFieldStore, CardFieldContextMenuItems} from '@modules'
import {useSpecificationCardStore} from '@modules/CatalogItemDetails'
import {useCatalog} from '@stores'

export const SidebarSpecificationCardContextMenu = observer(function SidebarSpecificationCardContextMenu() {
  const store = useSpecificationCardStore(),
    cardFieldStore = useCardFieldStore(),
    {idFor} = useCatalog()

  if (!store) return null

  const {associatedWorkspace, data} = store, id = idFor(data)

  return (
    <Fragment>
      {cardFieldStore ? cardFieldStore.contextMenuItems : <Fragment>
        {associatedWorkspace && <Fragment>
			<OpenInWorkspaceMenuItem workspace={associatedWorkspace?.workspace?.config} id={id}/>
			<OpenInC8MenuItem id={id}/>
			<MenuDivider/>
		</Fragment>}
        <DefaultCatalogContextMenuItems/>
      </Fragment>}
    </Fragment>
  )
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/SidebarSpecificationCardContextMenu.tsx